export default {
  languageDesc: 'English',
  demoAndDocument: 'Demo / Documents',
  changeLog: 'ChangeLog',
  project: 'Project',
  language: 'Language',
  jqSeries: 'jQuery Series plugins',
  jqVersion: 'jQuery version',
  homePageTitle: 'Terry <strong>Vue</strong> Component Series',

  install: 'Install',
  deploy: 'Deploy on your component',
  example: 'Examples',
  options: 'Options',
  events: 'Events',
  codePen: 'view examples on CodePen',
  showHideCode: 'Show/Hide code',
  selectedResults: 'Selected results',
  globalConfig: 'Can global config options in plugin install',

  guide: {
    useNpm: 'Use<strong class="px-2">npm</strong>to install plugin',
    include: 'Include plugin in your project entry<code class="px-2">main.js</code>file',
    customRegister: 'Custom global registration components',
    useGlobalComponent: 'Use globally registered components',
    useLocalComponent: 'Use locally registered components'
  },
  tbTitle: {
    name: 'name',
    type: 'type',
    desc: 'description',
    required: 'required',
    default: 'default',
    args: 'arguments',
    scope: 'scope',
    param: 'parameter name',
    prop: 'property name',
    apiName: 'method name'
  },
  lang: {
    desc: 'the language used by the plugin for i18n',
    cn: 'Chinese',
    en: 'English',
    jp: 'Japanese',
    ar: 'Arabic',
    es: 'Spanish',
    de: 'German',
    ro: 'Romanian',
    fr: 'French',
    pt_br: 'Portuguese-Brazil',
    pl: 'Polish',
    fa: 'Persian'
  }
}
